import { Injectable } from '@angular/core';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { ShowErrorModel } from '@bo-client/shared/form-errors/errors-form-model';
import {
  ErrorFormCommissioningEnum,
  ErrorFormsEnum
} from '@bo-client/activation-management/shared/forms/create-forms-errors-model';

@Injectable({
  providedIn: 'root'
})
export class ErrorsFormsService {
  constructor() {}

  checkTwoLevelFormErrors(
    form: FormGroup,
    errorDescription: ShowErrorModel[],
    formErrorList: ShowErrorModel[]
  ): ShowErrorModel[] {
    if (!formErrorList) {
      formErrorList = new Array<ShowErrorModel>();
    }
    for (let i = 0; i < Object.keys(form.controls).length; i++) {
      const controlName = Object.keys(form.controls)[i];
      if (
        (form.get(controlName)['controls'] as FormArray) &&
        (form.get(controlName)['controls'] as FormArray).length
      ) {
        // check control with Nested FormArray
        for (let i = 0; i < (<FormArray>form.get(controlName)).controls.length; i++) {
          const controlNameList = Object.keys((<FormArray>form.get(controlName)).controls[i]['controls']);
          for (let j = 0; j < controlNameList.length; j++) {
            let errorName: string = null;
            if (controlName === 'answers' || controlName === 'answersExpired') {
              errorName = (<FormArray>form.get(controlName)).controls[i].get('name').value;
            }
            this.checkErrorsInFormControl(
              (<FormArray>form.get(controlName)).controls[i].get(controlNameList[j]),
              controlName + '.' + controlNameList[j],
              errorDescription,
              formErrorList,
              errorName
            );
          }
        }
      } else {
        if ((form.get(controlName) as FormGroup).controls) {
          // check control with Nested FormGroups
          for (let j = 0; j < Object.keys(form.get(controlName)['controls']).length; j++) {
            const controlName2 = Object.keys(form.get(controlName)['controls'])[j];
            this.checkErrorsInFormControl(
              form.get(controlName).get(controlName2),
              controlName + '.' + controlName2,
              errorDescription,
              formErrorList,
              null
            );
          }
        } else {
          // check only one control
          this.checkErrorsInFormControl(
            form.get(controlName),
            controlName,
            errorDescription,
            formErrorList,
            null
          );
        }
      }
    }
    return formErrorList;
  }

  checkErrorsInFormControl(
    currentControl: AbstractControl,
    currentControlName: string,
    errorDescription: ShowErrorModel[],
    formErrorList: ShowErrorModel[],
    errorName: string
  ): ShowErrorModel[] {
    currentControl.updateValueAndValidity({ emitEvent: false });
    if (currentControl.invalid) {
      currentControl.markAsTouched();
      const newError: ShowErrorModel = new ShowErrorModel();
      newError.controlName = currentControlName;
      const idx = errorDescription.findIndex((ele) => ele.controlName === newError.controlName);
      let errorText: ShowErrorModel = new ShowErrorModel();
      if (idx === -1) {
        errorText.displayName = 'Field: ' + newError.controlName;
        errorText.errorMessage = ' has no error message. Please contact to Administrator';
      } else {
        errorText = errorDescription[idx];
        if (errorName != null) {
          errorText.errorMessage = errorName;
        }
      }
      newError.displayName = errorText.displayName;
      for (const item in ErrorFormsEnum) {
        if (currentControl.hasError(item)) {
          errorText.errorMessage = ErrorFormsEnum[item];
          break;
        }
      }
      newError.errorMessage = errorText.errorMessage;
      newError.step = errorText.step;
      formErrorList.push(newError);
    }
    return formErrorList;
  }

  updateErrorListAccordingCondition(hasError: boolean, fieldName: string, errorList: ShowErrorModel[]) {
    if (!errorList) {
      errorList = new Array<ShowErrorModel>();
    }
    const idxError = errorList.findIndex((ele) => ele.controlName == fieldName);
    if (hasError) {
      if (idxError === -1) {
        errorList.push(
          ErrorFormCommissioningEnum[
            ErrorFormCommissioningEnum.findIndex((ele) => ele.controlName == fieldName)
          ]
        );
      }
    } else {
      if (idxError !== -1) {
        errorList.splice(idxError, 1);
      }
    }
    return errorList;
  }
}
